export const OpsConsoleApps = [
    'paramountmsc.com'
];
export const PathBasedApps = [
    'admin-console',
    'fulfillment',
    'media-ingest-console',
    'c3',
    'partner',
    'qc-workbench',
    'media-hub',
    'linear-console',
    'chatbot'
];
const pathBasedHost = "operationsconsole.paramountmsc.com";
export const isRootApp = () => !!OpsConsoleApps.find(oc => window.location.href.includes(oc));
export const isPathBased = () => !!PathBasedApps.find(pc => window.location.href.includes(pc)
    && window.location.host.endsWith(pathBasedHost));
export const isLocationContentPlatform = () => window.location.href.includes('contentplatform.viacom.com');
export const isLocationPR = () => window.location.href.includes('pr.paramountmsc.com');
//# sourceMappingURL=ops-console-apps.js.map